import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Camera({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        fillRule="evenodd"
        d="M10 4C9.7902 4 9.59261 4.0988 9.46671 4.26667L7.66671 6.66667H2.00004C1.63185 6.66667 1.33337 6.96514 1.33337 7.33333V19.3333C1.33337 19.7015 1.63185 20 2.00004 20H22C22.3682 20 22.6667 19.7015 22.6667 19.3333V7.33333C22.6667 6.96514 22.3682 6.66667 22 6.66667H18.8367L19.8367 8H21.3334V18.6667H2.66671V8H8.00004C8.20988 8 8.40747 7.9012 8.53337 7.73333L10.3334 5.33333H13.6667L15.4667 7.73333C15.5926 7.9012 15.7902 8 16 8H17.3367L16.3367 6.66667H16.3334L14.5334 4.26667C14.4075 4.0988 14.2099 4 14 4H10ZM14.6667 13.3333C14.6667 14.8061 13.4728 16 12 16C10.5273 16 9.33337 14.8061 9.33337 13.3333C9.33337 11.8606 10.5273 10.6667 12 10.6667C13.4728 10.6667 14.6667 11.8606 14.6667 13.3333ZM16 13.3333C16 15.5425 14.2092 17.3333 12 17.3333C9.7909 17.3333 8.00004 15.5425 8.00004 13.3333C8.00004 11.1242 9.7909 9.33333 12 9.33333C14.2092 9.33333 16 11.1242 16 13.3333ZM18 10.3333C18 10.8856 18.4478 11.3333 19 11.3333C19.5523 11.3333 20 10.8856 20 10.3333C20 9.78105 19.5523 9.33333 19 9.33333C18.4478 9.33333 18 9.78105 18 10.3333Z"
        fill={iconColor}
      />
    </Svg>
  );
}
